import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutHazardousMaterialsCodesList extends Layout {
    layoutHeaderHazardousMaterialsCodes: LayoutHeader;
    sourceHazmatCode: DataSource;
    tableHazardousMaterialsCodes: Table;
}
